import React, { useEffect } from 'react';
import useExtendedEffect from '../../../../utilities/hooks/useExtendedEffect';
import useEffectAsync from '../../../../utilities/hooks/useEffectAsync';
import { connect } from 'react-redux';

import SaleFooter from '../Partials/SaleFooter/SaleFooter';
import { goToPage, updateConverter, reportDWH , setIsLoadingShoppingCart} from '../saleJetBlockSlice';
import { getSalePricesAsync, getTechnicianTimesAsync, getCustomerAddresses } from '../saleBlockAsyncThunk';
import Converters from '../Partials/Converters/Converters';
import {gtag4} from '../../../../utilities/analytics/tracking';

const ConvertersPage = (props) => {

  useEffect(() => {
    props.setIsLoadingShoppingCart(false);
    props.reportDWH({ actionType: 'Converters Amount', status: 'Ongoing', messageText: 'Converters Amount Page Displayed' });
    gtag4({
      event: `${props.saleType}_Step5_ConverterPage`,
      step: '5',
      action:  'ConverterPage',
      funnel_name: `${props.saleType}_Exists${props.flowType == 'existsCustomer' ? '_Exists' : '_New'}_Customer`
    });
  }, []);

  //page params
  let isDisplayFooter = true;
  let btnText = 'המשך';
  let currentPageFunction = handlePageContinue;
  let totalPrice = null;
  let priceText = '';
  let formid = 'saleJet';
  //page params

  let title = '';
  let subTitle = '';

  if (props.orderType == 'replace') {
    title = (<> ממיר ראשון לצפייה ב4K <br />מתנה מאיתנו </>);
    subTitle = (<>  אלו הממירים שברשותך, האם תרצה להוסיף עוד? </>);
  }
  else {
    subTitle = (<> כמה ממירים לארוז לך? </>);
  }

  let currentPageHeadline = (
    <div className='page-headline-wrapper'>
      <h1 className='sale-title'></h1>
      <h1 className='sale-title-big'> {title} </h1>
      <h2 className='sale-title-small'> {subTitle} </h2>
    </div>
  );

  let currentPageView = null;
  if (props.converters && props.converters.length > 0) {
    currentPageView = <Converters converters={groupArrayOfObjects(props.converters)} onUpdateConverter={handleUpdateConverter} isLoadingShoppingCart={props.isLoadingShoppingCart} minimumConverters={props.minimumConverters} maximumConverters={props.maximumConverters} supportedTvImage={props.supportedTvImage} supportedTvPopupText={props.supportedTvPopupText} convertersInfoPopupText={props.convertersInfoPopupText} />;
  }

  return (
    <div className='slideAnimation'>
      {currentPageHeadline}
      <div className='sale-page-content'>
        <form noValidate id='sale' onSubmit={handleSubmit}>
          {currentPageView}
        </form>
        <SaleFooter isDisplayFooter={isDisplayFooter} btnText={btnText} onclick={currentPageFunction} price={totalPrice} priceText={priceText} formid={formid} />
      </div>
    </div>
  );


  function handleUpdateConverter(data) {

    if (data.action == 'remove') {
      const converters = props.converters.filter(x => x.action == 'Add');
      if (converters.length == 0) { return; }

      if (converters.length <= props.selectedPackage.minimumConvertersAmount) {
        console.log('minimumConvertersAmount', props.selectedPackage.minimumConvertersAmount);
        return;
      }
    }

    props.updateConverter(data);
    props.getSalePricesAsync();
  }

  function handlePageContinue() {
    if(props.isHidePremiumPackagesPage){
      switch (props.saleType) {
        case 'tv':
          if(props.addons?.length >= 1 ) {
            props.goToPage('addonsPage');
          }else {
            props.goToPage('addressPage');
            props.reportDWH({ actionType: 'Service Address', status: 'Ongoing', messageText: 'Service Address Page Displayed' });
          }
          break;
        case 'triple':
          if(props.addons?.length > 0) {
            props.goToPage('addonsPage');
          } else {
            props.getTechnicianTimesAsync();
          }
          break;
      }
    }else{
      props.goToPage('premiumPackagesPage');
    }
    props.reportDWH({ actionType: 'Converters Amount', status: 'Ongoing', messageText: 'Converters Amount Page Button Clicked' });
    gtag4({
      event: `${props.saleType}_Step5_ConverterContinueButton`,
      step: '5',
      button: btnText,
      action:  'ConverterContinueButton',
      funnel_name: `${props.saleType}_Exists${props.flowType == 'existsCustomer' ? '_Exists' : '_New'}_Customer`
    });
  }

  function handleSubmit(event) {
    event.preventDefault();
  }

  function groupArrayOfObjects(list) {
    const groups = list.reduce((groups, item) => {
      if (!groups[item.name]) { groups[item.name] = []; }
      groups[item.name].push(item);
      return groups;
    }, {});

    const groupArrays = Object.keys(groups).map((name) => {
      return {
        name,
        cmsData: groups[name][0]?.cmsData,
        converterList: groups[name],
      };
    });

    return groupArrays;
  };

};

const mapStateToProps = (state) => {
  return {
    saleType: state.saleJetBlock.saleType,
    orderType: state.saleJetBlock.orderType,
    flowType: state.saleJetBlock.flowType,
    offerName: state.saleJetBlock.offerName,
    converters: state.saleJetBlock.saleCatalog?.converters,
    selectedPackage: state.saleJetBlock.selectedPackage,
    isLoadingShoppingCart: state.saleJetBlock.isLoadingShoppingCart,
    minimumConverters: state.saleJetBlock.selectedPackage.minimumConvertersAmount,
    maximumConverters: state.saleJetBlock.saleBlockData.maximumConverters,
    supportedTvImage: state.saleJetBlock.saleBlockData.supportedTvImage,
    supportedTvPopupText: state.saleJetBlock.saleBlockData.supportedTvPopupText,
    convertersInfoPopupText: state.saleJetBlock.saleBlockData.convertersInfoPopupText,
    isHidePremiumPackagesPage: state.saleJetBlock.saleBlockData.isHidePremiumPackagesPage,
    addons: state.saleJetBlock.saleCatalog?.addons,
  };
};

const mapDispatchToProps = {
  goToPage,
  getSalePricesAsync,
  getTechnicianTimesAsync,
  getCustomerAddresses,
  updateConverter,
  reportDWH,
  setIsLoadingShoppingCart
};

export default connect(mapStateToProps, mapDispatchToProps)(ConvertersPage);
